import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { ActionInfoBox } from '@sellpy/design-system-react-web'

const StyledActionInfoBox = styled(ActionInfoBox)`
  margin-bottom: 8px;
`

export const ERRORS = {
  PARSE_ERROR: 'parseError',
  ADYEN_ERROR: 'adyenPaymentOptions',
  KLARNA_ERROR: 'klarnaPaymentOptions',
  INVALID_FORM_DATA: 'invalidFormData'
}

const formErrors = ({ details }, t) => {
  const definedErrorsDetails = {
    invalidFormData: {
      headline: t('adyenSessionPayment:errorHandler.parse.general.headline'),
      subheadline: t('adyenSessionPayment:errorHandler.parse.general.subheadline')
    }
  }
  return (
    definedErrorsDetails[details?._error] || {
      headline: t('adyenSessionPayment:errorHandler.parse.general.headline'),
      subheadline: t('adyenSessionPayment:errorHandler.parse.general.subheadline')
    }
  )
}

const parseParseErrors = ({ details }, t) => {
  const definedErrorsDetails = {
    reservationsNotInSync: {
      headline: t('adyenSessionPayment:errorHandler.parse.reservationsNotInSync.headline'),
      subheadline: t('adyenSessionPayment:errorHandler.parse.reservationsNotInSync.subheadline')
    },
    invalidCreditAmount: {
      headline: t('adyenSessionPayment:errorHandler.parse.invalidCreditAmount.headline'),
      subheadline: t('adyenSessionPayment:errorHandler.parse.invalidCreditAmount.subheadline')
    },
    paymentAlreadyOngoing: {
      headline: t('adyenSessionPayment:errorHandler.parse.paymentAlreadyOngoing.headline'),
      subheadline: t('adyenSessionPayment:errorHandler.parse.paymentAlreadyOngoing.subheadline')
    },
    priceIncreasedTooMuch: {
      headline: t('adyenSessionPayment:errorHandler.parse.priceIncreasedTooMuch.headline'),
      subheadline: t('adyenSessionPayment:errorHandler.parse.priceIncreasedTooMuch.subheadline')
    },
    ongoingSendBackRequest: {
      headline: t('adyenSessionPayment:errorHandler.parse.ongoingSendBackRequest.headline'),
      subheadline: t('adyenSessionPayment:errorHandler.parse.ongoingSendBackRequest.subheadline')
    }
  }
  return (
    definedErrorsDetails[details?._error] || {
      headline: t('adyenSessionPayment:errorHandler.parse.general.headline'),
      subheadline: t('adyenSessionPayment:errorHandler.parse.general.subheadline')
    }
  )
}

const adyenParseErrors = (error, t) => {
  const definedErrorsDetails = {
    'swish App was not found': {
      headline: t('adyenSessionPayment:errorHandler.adyen.swishAppwasnotfound.headline'),
      subheadline: t('adyenSessionPayment:errorHandler.adyen.swishAppwasnotfound.subheadline')
    },
    Refused: {
      headline: t('adyenSessionPayment:errorHandler.adyen.refused.headline'),
      subheadline: t('adyenSessionPayment:errorHandler.adyen.refused.subheadline')
    }
  }
  return (
    definedErrorsDetails[error.message] || {
      headline: t('adyenSessionPayment:errorHandler.adyen.general.headline'),
      subheadline: t('adyenSessionPayment:errorHandler.adyen.general.subheadline')
    }
  )
}

const klarnaErrors = (res, t) => {
  if (res.show_form && res.error)
    return {
      headline: t('common:errorToast.header'),
      subheadline: t('checkout:klarnaError.fixableError.body')
    }

  if (res.show_form && !res.error)
    return {
      headline: t('checkout:klarnaError.paymentTerminated.header'),
      subheadline: t('checkout:klarnaError.paymentTerminated.body')
    }

  return {
    headline: t('common:errorToast.header'),
    subheadline: t('common:errorToast.body')
  }
}

const _isFormValidationError = (error) => error.type === 'validate'

const ErrorHandler = ({ errors, clearErrors }) => {
  const { t } = useTranslation(['adyenSessionPayment', 'checkout', 'common'])

  const parseError = errors[ERRORS.PARSE_ERROR]
  if (parseError) {
    const { headline, subheadline } = parseParseErrors(parseError.message, t)
    return (
      <StyledActionInfoBox backgroundColor={'red'} headline={headline} subHeadline={subheadline} />
    )
  }

  const adyenError = errors[ERRORS.ADYEN_ERROR]
  if (adyenError && !_isFormValidationError(adyenError)) {
    if (adyenError?.name === 'CANCEL') {
      clearErrors(ERRORS.ADYEN_ERROR)
      return <div />
    }
    const { headline, subheadline } = adyenParseErrors(adyenError, t)
    return (
      <StyledActionInfoBox backgroundColor={'red'} headline={headline} subHeadline={subheadline} />
    )
  }

  const klarnaError = errors[ERRORS.KLARNA_ERROR]
  if (klarnaError) {
    const { headline, subheadline } = klarnaErrors(klarnaError, t)
    return (
      <StyledActionInfoBox backgroundColor={'red'} headline={headline} subHeadline={subheadline} />
    )
  }

  const formError = errors[ERRORS.INVALID_FORM_DATA]
  if (formError) {
    const { headline, subheadline } = formErrors(formError, t)
    return (
      <StyledActionInfoBox backgroundColor={'red'} headline={headline} subHeadline={subheadline} />
    )
  }

  return <div />
}

export default ErrorHandler
